import React from "react";

import {connect} from "react-redux";

import {
  Edit,
  translate,
  ImageField,
  TabbedForm,
  FormTab
} from "admin-on-rest";

import ImageInput from "../../../components/CRM/ImageInput";
import ColorInput from "../../../components/ColorInput";
import BooleanField from "../../../components/CRM/BooleanField";

import {validateStyle, validateBackgroundColor, validateTextColor} from "./validations";

import {formStyle} from "./style";

const dimensions = {
  logo: {
    imageWidth: "150",
    imageHeight: "30"
  }
};

const imageLabel = {
  logo: `${dimensions.logo.imageWidth} x ${dimensions.logo.imageHeight}`,
};

const MarketingPartnerTitleBase = ({record, translate}) => {
  return (
    <span style={formStyle.titleStyle}>
      {translate("resources.marketingPartners.titleEdit")} {record ? `${record.name}` : ""}
    </span>
  );
};

const MarketingPartnerTitle = translate(MarketingPartnerTitleBase);

class MarketingPartnerEditForm extends React.Component {
  render() {
    const props = {...this.props};
    const reduxErrors = {...props.errors};
    const errors = {...reduxErrors.syncErrors};
    const {translate} = props;
    return (      
      <Edit title={<MarketingPartnerTitle />} {...props}>
        <TabbedForm redirect="list" validate={validateStyle}>
          <FormTab label="resources.marketingPartners.titleTabFeatures">
            <BooleanField
              style={formStyle.booleanFieldStyle}
              label={translate(`resources.marketingPartners.fields.features.integration`)}
              source={`features.integration`}
            />
            <BooleanField
              style={formStyle.booleanFieldStyle}
              label={translate(`resources.marketingPartners.fields.features.signup_sms`)}
              source={`features.signup_sms`}
            />
            <BooleanField
              style={formStyle.booleanFieldStyle}
              label={translate(`resources.marketingPartners.fields.features.signup_url`)}
              source={`features.signup_url`}
            />
            <BooleanField
              style={formStyle.booleanFieldStyle}
              label={translate(`resources.marketingPartners.fields.features.affiliate_links`)}
              source={`features.affiliate_links`}
            />
            <BooleanField
              style={formStyle.booleanFieldStyle}
              label={translate(`resources.marketingPartners.fields.features.gift_card`)}
              source={`features.gift_card`}
            />
          </FormTab>
          <FormTab
            label="resources.marketingPartners.titleTabWebStyle"
            elStyle={formStyle.tabStyle}>
            <ImageInput
              {...props}
              source="web_offer_style.logo"
              label={translate("resources.marketingPartners.inputs.webOfferStyle.logo", {
                dimensions: imageLabel.logo
              })}
              accept="image/*"
              validWidth={dimensions.logo.imageWidth}
              validHeight={dimensions.logo.imageHeight}
              style={formStyle.imageStyle}
            >
              <ImageField  source="src" title="title" />
            </ImageInput>

            <div style={formStyle.clearFloatContainer} />

            <ColorInput
              source="web_offer_style.styles.color"
              validate={validateTextColor}
              label={translate("resources.marketingPartners.inputs.webOfferStyle.textColor")}/>
            
            <ColorInput
              source="web_offer_style.styles.background-color"
              validate={validateBackgroundColor}
              label={translate("resources.marketingPartners.inputs.webOfferStyle.backgroundColor")}/>
          </FormTab>
        </TabbedForm>
      </Edit>
    );
  }
}



const mapStateToProps = (state, props) => ({
  errors: state.form[`record-form`],
  configuration: state.configuration,
  id: decodeURIComponent(props.match.params.id),
  record: state.admin.resources[props.resource]
    ? state.admin.resources[props.resource].data[
        decodeURIComponent(props.match.params.id)
      ]
    : null,
});

const mapDispatchToProps = {
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate(MarketingPartnerEditForm));



// WEBPACK FOOTER //
// ./src/containers/CRM/MarketingPartners/MarketingPartnerEditForm.js